import React, { useEffect } from "react";
import AddPhoto from "../addPhoto/AddPhoto";
import TextEditor from "../textEditor/TextEditor";
import TextInput from "../textInput/TextInput";
import { useState } from "react";

const IFrame5Field = ({
    addImageHandler,
    selectedImages,
    changeImgStatus,
    changeImgSubtitle,
    setIframeList,
    index,
    iFrameData,
}) => {
    const [title, setTitle] = useState("");
    const [text1, setText1] = useState("");
    const [text2, setText2] = useState("");
    const [text3, setText3] = useState("");
    const [text4, setText4] = useState("");
    const [text5, setText5] = useState("");
    const [text6, setText6] = useState("");
    const [text7, setText7] = useState("");
    const [text8, setText8] = useState("");

    const framDataList = {
        id: 5,
        title: title,
        fields: {
            field_1: {
                type: "ckeditor",
                content: text1,
            },
            field_2: {
                type: "ckeditor",
                content: text2,
            },
            field_3: {
                type: "ckeditor",
                content: text3,
            },
            field_4: {
                type: "ckeditor",
                content: text4,
            },
            field_5: {
                type: "image",
                id: "img1-" + index,
                content: selectedImages["img1-" + index],
            },
            field_6: {
                type: "image",
                id: "img2-" + index,
                content: selectedImages["img2-" + index],
            },
            field_7: {
                type: "image",
                id: "img3-" + index,
                content: selectedImages["img3-" + index],
            },
            field_8: {
                type: "image",
                id: "img4-" + index,
                content: selectedImages["img4-" + index],
            },
            field_9: {
                type: "ckeditor",
                content: text5,
            },
            field_10: {
                type: "ckeditor",
                content: text6,
            },
            field_11: {
                type: "ckeditor",
                content: text7,
            },
            field_12: {
                type: "ckeditor",
                content: text8,
            },
            field_13: {
                type: "image",
                id: "img5-" + index,
                content: selectedImages["img5-" + index],
            },
            field_14: {
                type: "image",
                id: "img6-" + index,
                content: selectedImages["img6-" + index],
            },
            field_15: {
                type: "image",
                id: "img7" + index,
                content: selectedImages["img7-" + index],
            },
            field_16: {
                type: "image",
                id: "img8-" + index,
                content: selectedImages["img8-" + index],
            },
        },
    };

    useEffect(() => {
        setIframeList((prev) => {
            let newArr = prev;
            prev[index] = framDataList;
            return newArr;
        });
    }, [selectedImages, text1, text2, text3, text4, text5, text6, text7, text8, title]);

    useEffect(() => {
        if (iFrameData) {
            setTitle(iFrameData?.title);
            setText1(iFrameData?.fields?.field_1?.content);
            setText2(iFrameData?.fields?.field_2?.content);
            setText3(iFrameData?.fields?.field_3?.content);
            setText4(iFrameData?.fields?.field_4?.content);
            setText5(iFrameData?.fields?.field_9?.content);
            setText6(iFrameData?.fields?.field_10?.content);
            setText7(iFrameData?.fields?.field_11?.content);
            setText8(iFrameData?.fields?.field_12?.content);
        }
    }, [iFrameData]);

    return (
        <div className="fields-list">
            <div className="create-iframe__param">
                <div className="input-lable">Заголовок</div>
                <TextInput inputValue={title} setInputValue={(value) => setTitle(value)} />
            </div>
            <div className="create-iframe__param">
                <div className="input-lable">Текст ряд: 1 - №1</div>
                <TextEditor setText={setText1} text={text1} />
            </div>
            <div className="create-iframe__param">
                <div className="input-lable">Текст ряд: 1 - №2</div>
                <TextEditor setText={setText2} text={text2} />
            </div>
            <div className="create-iframe__param">
                <div className="input-lable">Текст ряд: 1 - №3</div>
                <TextEditor setText={setText3} text={text3} />
            </div>
            <div className="create-iframe__param">
                <div className="input-lable">Текст ряд: 1 - №4</div>
                <TextEditor setText={setText4} text={text4} />
            </div>
            <div className="create-iframe__param">
                <AddPhoto
                    lable={"Фото ряд: 2 - №1"}
                    onClick={() => addImageHandler("img1-" + index)}
                    imgId={"img1-" + index}
                    imgData={selectedImages["img1-" + index]}
                    changeImgStatus={changeImgStatus}
                    changeImgSubtitle={changeImgSubtitle}
                />
            </div>
            <div className="create-iframe__param">
                <AddPhoto
                    lable={"Фото ряд: 2 - №2"}
                    onClick={() => addImageHandler("img2-" + index)}
                    imgId={"img2-" + index}
                    imgData={selectedImages["img2-" + index]}
                    changeImgStatus={changeImgStatus}
                    changeImgSubtitle={changeImgSubtitle}
                />
            </div>
            <div className="create-iframe__param">
                <AddPhoto
                    lable={"Фото ряд: 2 - №3"}
                    onClick={() => addImageHandler("img3-" + index)}
                    imgId={"img3-" + index}
                    imgData={selectedImages["img3-" + index]}
                    changeImgStatus={changeImgStatus}
                    changeImgSubtitle={changeImgSubtitle}
                />
            </div>
            <div className="create-iframe__param">
                <AddPhoto
                    lable={"Фото ряд: 2 - №4"}
                    onClick={() => addImageHandler("img4-" + index)}
                    imgId={"img4-" + index}
                    imgData={selectedImages["img4-" + index]}
                    changeImgStatus={changeImgStatus}
                    changeImgSubtitle={changeImgSubtitle}
                />
            </div>
            <div className="create-iframe__param">
                <div className="input-lable">Текст ряд: 3 - №1</div>
                <TextEditor setText={setText5} text={text5} />
            </div>
            <div className="create-iframe__param">
                <div className="input-lable">Текст ряд: 3 - №2</div>
                <TextEditor setText={setText6} text={text6} />
            </div>
            <div className="create-iframe__param">
                <div className="input-lable">Текст ряд: 3 - №3</div>
                <TextEditor setText={setText7} text={text7} />
            </div>
            <div className="create-iframe__param">
                <div className="input-lable">Текст ряд: 3 №4</div>
                <TextEditor setText={setText8} text={text8} />
            </div>
            <div className="create-iframe__param">
                <AddPhoto
                    lable={"Фото ряд: 4 - №1"}
                    onClick={() => addImageHandler("img5-" + index)}
                    imgId={"img5-" + index}
                    imgData={selectedImages["img5-" + index]}
                    changeImgStatus={changeImgStatus}
                    changeImgSubtitle={changeImgSubtitle}
                />
            </div>
            <div className="create-iframe__param">
                <AddPhoto
                    lable={"Фото ряд: 4 - №2"}
                    onClick={() => addImageHandler("img6-" + index)}
                    imgId={"img6-" + index}
                    imgData={selectedImages["img6-" + index]}
                    changeImgStatus={changeImgStatus}
                    changeImgSubtitle={changeImgSubtitle}
                />
            </div>
            <div className="create-iframe__param">
                <AddPhoto
                    lable={"Фото ряд: 4 - №3"}
                    onClick={() => addImageHandler("img7-" + index)}
                    imgId={"img7-" + index}
                    imgData={selectedImages["img7-" + index]}
                    changeImgStatus={changeImgStatus}
                    changeImgSubtitle={changeImgSubtitle}
                />
            </div>
            <div className="create-iframe__param">
                <AddPhoto
                    lable={"Фото ряд: 4 - №4"}
                    onClick={() => addImageHandler("img8-" + index)}
                    imgId={"img8-" + index}
                    imgData={selectedImages["img8-" + index]}
                    changeImgStatus={changeImgStatus}
                    changeImgSubtitle={changeImgSubtitle}
                />
            </div>
        </div>
    );
};

export default IFrame5Field;
